exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.supreme-vip-dialog .supreme-vip-content[data-v-6b50b06f] {\n  width: 8.266667rem;\n  height: 10rem;\n  background-size: 100% 100%;\n  margin: 0 auto;\n}\n.supreme-vip-dialog .supreme-vip-content .apply-btn[data-v-6b50b06f] {\n  position: relative;\n  top: 7.08rem;\n  width: 5.866667rem;\n  height: 1.066667rem;\n  margin: 0 auto;\n  font-size: 0.48rem;\n  font-family: PingFangSC-Semibold, PingFang SC;\n  font-weight: 600;\n  color: #FFFFFF;\n  line-height: 0.666667rem;\n}", ""]);

// exports
